"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNAUTHENTICATED_MOBILE_AUTHENTICATOR_LAMBDA_ARNS = exports.MOBILE_AUTHENTICATOR_LAMBDA_ARNS = exports.BLOCKING_AUTHENTICATOR_LAMBDA_ARNS = exports.COOKIE_AUTHENTICATOR_LAMBDA_ARNS = void 0;
const Stage_1 = require("./Stage");
/**
 * See https://github.com/eventbrite/tlz-request-based-authorizer-infra for more details
 */
exports.COOKIE_AUTHENTICATOR_LAMBDA_ARNS = {
    [Stage_1.Stage.LOCAL]: "arn:aws:lambda:us-east-1:477496631753:function:unauthenticated_authorizer:current",
    [Stage_1.Stage.DEV]: "arn:aws:lambda:us-east-1:477496631753:function:unauthenticated_authorizer:current",
    [Stage_1.Stage.TEST]: "arn:aws:lambda:us-east-1:686954813705:function:unauthenticated_authorizer:current",
    [Stage_1.Stage.PROD]: "arn:aws:lambda:us-east-1:971103245699:function:unauthenticated_authorizer:current",
};
exports.BLOCKING_AUTHENTICATOR_LAMBDA_ARNS = {
    [Stage_1.Stage.LOCAL]: "arn:aws:lambda:us-east-1:477496631753:function:authenticated_signed_cookie_authorizer:current",
    [Stage_1.Stage.DEV]: "arn:aws:lambda:us-east-1:477496631753:function:authenticated_signed_cookie_authorizer:current",
    [Stage_1.Stage.TEST]: "arn:aws:lambda:us-east-1:686954813705:function:authenticated_signed_cookie_authorizer:current",
    [Stage_1.Stage.PROD]: "arn:aws:lambda:us-east-1:971103245699:function:authenticated_signed_cookie_authorizer:current",
};
exports.MOBILE_AUTHENTICATOR_LAMBDA_ARNS = {
    [Stage_1.Stage.LOCAL]: "arn:aws:lambda:us-east-1:477496631753:function:mobile_authorizer:current",
    [Stage_1.Stage.DEV]: "arn:aws:lambda:us-east-1:477496631753:function:mobile_authorizer:current",
    [Stage_1.Stage.TEST]: "arn:aws:lambda:us-east-1:686954813705:function:mobile_authorizer:current",
    [Stage_1.Stage.PROD]: "arn:aws:lambda:us-east-1:971103245699:function:mobile_authorizer:current",
};
exports.UNAUTHENTICATED_MOBILE_AUTHENTICATOR_LAMBDA_ARNS = {
    [Stage_1.Stage.LOCAL]: "arn:aws:lambda:us-east-1:477496631753:function:unauthenticated_mobile_authorizer:current",
    [Stage_1.Stage.DEV]: "arn:aws:lambda:us-east-1:477496631753:function:unauthenticated_mobile_authorizer:current",
    [Stage_1.Stage.TEST]: "arn:aws:lambda:us-east-1:686954813705:function:unauthenticated_mobile_authorizer:current",
    [Stage_1.Stage.PROD]: "arn:aws:lambda:us-east-1:971103245699:function:unauthenticated_mobile_authorizer:current",
};
//# sourceMappingURL=lambdaAuthenticators.js.map